import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Handles return from Emergent Google Auth — exchanges session_id, sets cookie, redirects. */
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Strip the hash from the URL immediately
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true },
        );
        await refresh();
        if (data.is_admin) {
          toast.success(`Welcome, ${data.name || data.email}`);
          navigate("/admin", { replace: true, state: { user: data } });
        } else {
          toast.error("That Google account isn't authorized for the admin panel.");
          navigate("/", { replace: true });
        }
      } catch (err) {
        console.error("Session exchange failed:", err?.message || err);
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-primary">
      <div className="text-center">
        <div className="font-mono text-xs tracking-[0.25em] text-signal uppercase mb-4 flex items-center justify-center gap-3">
          <span className="inline-block w-8 h-[2px] bg-signal animate-pulse" />
          Verifying Session
        </div>
        <div className="heading text-2xl text-white">Signing you in…</div>
      </div>
    </div>
  );
}
